import { useCallback } from "react";
import { ChevronDown } from "lucide-react";
import Checkbox from "../core/Checkbox";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../shadcn/DropDownMenu";
import { SelectedListingsType } from "./useSearchListingsPage";

interface BatchSelectionProps {
  isSelectAllChecked: boolean;
  toggleSelectAll: (checked: boolean) => void;
  onListingsTypeClick: (type: SelectedListingsType) => void;
  isBatchSelectionActive: boolean;
}

export const BatchSelection = ({
  isSelectAllChecked,
  toggleSelectAll,
  onListingsTypeClick,
  isBatchSelectionActive,
}: BatchSelectionProps) => {
  const handleSelectAllOptions = useCallback(
    (option: string) => {
      switch (option) {
        case "page":
          onListingsTypeClick(SelectedListingsType.selections);
          toggleSelectAll(true);
          break;
        case "none":
          onListingsTypeClick(SelectedListingsType.selections);
          toggleSelectAll(false);
          break;
        default:
          break;
      }
    },
    [onListingsTypeClick, toggleSelectAll]
  );

  return (
    <div className="flex items-center gap-2">
      {isBatchSelectionActive && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <div className="flex items-center gap-1 cursor-pointer select-all-checkbox">
              <Checkbox
                checked={isSelectAllChecked}
                onCheckedChange={toggleSelectAll}
              />
              <ChevronDown className="h-3 w-3" />
            </div>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start">
            <DropdownMenuItem onClick={() => handleSelectAllOptions("page")}>
              All on Page
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => handleSelectAllOptions("none")}>
              None
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
};
